import "./DataExport.css";
import { useRef } from "react";
import domtoimage from "dom-to-image";

export default function DataExport() {
	const paperRef = useRef(null);

	const downloadImage = () => {
		if (paperRef.current) {
			domtoimage.toPng(paperRef.current)
				.then((dataUrl) => {
					console.log(dataUrl)
				})
				.catch((error) => {
					console.error('oops, something went wrong!', error)
				})
		}
	}

	return (
		<div style={{ overflowY: "scroll", flex: 1, justifyContent: "center", alignContent: "center", flexDirection: "column", paddingTop: 400 }}>
			<div ref={paperRef} id="A4-paper">
				<img src={require("../../Assets/Images/SchoolLogo.png")} alt="school logo" id="school-logo" />
				<h1 className="export-text" style={{ textAlign: "center", marginLeft: "auto", marginRight: "75px", marginTop: "-20%" }}>
					محافظة المنيا
					<br />
					إدارة المنيا التعليمية
					<br />
					{process.env.REACT_APP_SCHOOL_NAME_AR}
				</h1>
				<h1 className="export-text" style={{ marginLeft: "auto", marginRight: "25px", marginTop: "65px" }}>
					غياب وحضور الطلاب عن يوم {new Date().toLocaleDateString("ar-EG", { weekday: "long" })} الموافق:
					<br />
					{new Date().toLocaleDateString("ar-EG") + "م"}
				</h1>
				<table>
					<thead>
						<tr>
							<th rowSpan={2}>الفصل</th>
							<th colSpan={3} style={{ padding: 5 }}>العدد</th>
							<th rowSpan={2}>أسماء الغائبين</th>
							<th rowSpan={2}>توقيع المعلم</th>
						</tr>
						<tr>
							<th style={{ padding: 5 }}>مقيد</th>
							<th style={{ padding: 5 }}>غائب</th>
							<th style={{ padding: 5 }}>حاضر</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style={{ direction: "ltr" }}>10/A</td>
							<td>32</td>
							<td>17</td>
							<td>15</td>
							<td style={{ maxWidth: "200px" }}>أحمد شمنسمؤ شمنةمشؤس مشؤنسةمس مشؤنةسمؤ - شؤسنةشمؤس - شسؤمةمش -شسؤمةشؤس - مشؤنسةمشسؤ 0 مشنسؤةمسؤن</td>
							<td>Aaser</td>
						</tr>
					</tbody>
				</table>
			</div>
			<button onClick={downloadImage}>Download</button>
		</div>
	);
}